var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900919 2.9771C2.17479 1.74581 3.85318 1.06452 5.62737 1.06452C7.39802 1.06452 9.0764 1.74226 10.3538 2.97355C10.4567 3.0729 10.5916 3.12258 10.7229 3.12258C10.8612 3.12258 11.0032 3.06935 11.1061 2.95935C11.3119 2.74645 11.3048 2.40935 11.0919 2.2071C9.61576 0.784194 7.67479 0 5.62737 0C3.57995 0 1.63898 0.784193 0.162854 2.21064C-0.0500497 2.41645 -0.0535984 2.75 0.14866 2.9629C0.350918 3.17581 0.688015 3.17935 0.900919 2.9771Z",
    fill: "#141515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0474 2.25321C11.0476 2.25331 11.0477 2.25345 11.0478 2.25356ZM0.900919 2.9771C2.17479 1.74581 3.85318 1.06452 5.62737 1.06452C7.39802 1.06452 9.0764 1.74226 10.3538 2.97355C10.4567 3.0729 10.5916 3.12258 10.7229 3.12258C10.8612 3.12258 11.0032 3.06935 11.1061 2.95935C11.3119 2.74645 11.3048 2.40935 11.0919 2.2071C9.61576 0.784194 7.67479 0 5.62737 0C3.57995 0 1.63898 0.784193 0.162854 2.21064C-0.0500497 2.41645 -0.0535984 2.75 0.14866 2.9629C0.350918 3.17581 0.688015 3.17935 0.900919 2.9771Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14781 4.9216C9.28265 4.9216 9.41749 4.87192 9.52394 4.76902C9.73329 4.56321 9.7333 4.22612 9.52749 4.01676C8.48781 2.96644 7.10394 2.3916 5.62781 2.3916C4.15168 2.3916 2.76781 2.96999 1.72813 4.01676C1.52233 4.22612 1.52233 4.56321 1.73168 4.76902C1.94104 4.97483 2.27813 4.97483 2.48394 4.76547C3.32136 3.92096 4.4391 3.45257 5.62781 3.45257C6.81652 3.45257 7.93072 3.91741 8.77168 4.76547C8.87459 4.86838 9.00942 4.9216 9.14781 4.9216Z",
    fill: "#141515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72813 4.01676C2.76781 2.96999 4.15168 2.3916 5.62781 2.3916C7.10394 2.3916 8.48781 2.96644 9.52749 4.01676C9.7333 4.22612 9.73329 4.56321 9.52394 4.76902C9.41749 4.87192 9.28265 4.9216 9.14781 4.9216C9.00942 4.9216 8.87459 4.86838 8.77168 4.76547C7.93072 3.91741 6.81652 3.45257 5.62781 3.45257C4.4391 3.45257 3.32136 3.92096 2.48394 4.76547C2.27813 4.97483 1.94104 4.97483 1.73168 4.76902C1.52233 4.56321 1.52233 4.22612 1.72813 4.01676Z",
    fill: "#404040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95524 5.85138C7.36621 5.17364 6.51815 4.78687 5.6275 4.78687C4.73686 4.78687 3.88524 5.17364 3.29976 5.85138C3.10815 6.07493 3.12944 6.40848 3.35299 6.60364C3.45234 6.69235 3.57653 6.73493 3.70073 6.73493C3.84976 6.73493 3.99879 6.67461 4.1017 6.55041C4.48847 6.10686 5.04202 5.85138 5.6275 5.85138C6.21299 5.85138 6.76653 6.10686 7.15331 6.55041C7.34492 6.77041 7.68202 6.79525 7.90557 6.60364C8.12557 6.41203 8.14686 6.07493 7.95524 5.85138Z",
    fill: "#141515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35299 6.60364C3.45234 6.69235 3.57653 6.73493 3.70073 6.73493C3.84976 6.73493 3.99879 6.67461 4.1017 6.55041C4.48847 6.10686 5.04202 5.85138 5.6275 5.85138C6.21299 5.85138 6.76653 6.10686 7.15331 6.55041C7.34492 6.77041 7.68202 6.79525 7.90557 6.60364C8.12557 6.41203 8.14686 6.07493 7.95524 5.85138C7.36621 5.17364 6.51815 4.78687 5.6275 4.78687C4.73686 4.78687 3.88524 5.17364 3.29976 5.85138C3.10815 6.07493 3.12944 6.40848 3.35299 6.60364Z",
    fill: "#404040"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C10 6.17157 10.6716 5.5 11.5 5.5H20.5C21.3284 5.5 22 6.17157 22 7V24.5C22 24.7761 21.7761 25 21.5 25C21.2239 25 21 24.7761 21 24.5V7C21 6.72386 20.7761 6.5 20.5 6.5H11.5C11.2239 6.5 11 6.72386 11 7V24.5C11 24.7761 10.7761 25 10.5 25C10.2239 25 10 24.7761 10 24.5V7Z",
    fill: "#404040"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C4 13.1716 4.67157 12.5 5.5 12.5H10C10.2761 12.5 10.5 12.7239 10.5 13C10.5 13.2761 10.2761 13.5 10 13.5H5.5C5.22386 13.5 5 13.7239 5 14V24.5C5 24.7761 4.77614 25 4.5 25C4.22386 25 4 24.7761 4 24.5V14Z",
    fill: "#404040"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 16.5C6.5 16.2239 6.72386 16 7 16L10 16C10.2761 16 10.5 16.2239 10.5 16.5C10.5 16.7761 10.2761 17 10 17L7 17C6.72386 17 6.5 16.7761 6.5 16.5Z",
    fill: "#404040"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 19.5C6.5 19.2239 6.72386 19 7 19L10 19C10.2761 19 10.5 19.2239 10.5 19.5C10.5 19.7761 10.2761 20 10 20L7 20C6.72386 20 6.5 19.7761 6.5 19.5Z",
    fill: "#404040"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 22.5C6.5 22.2239 6.72386 22 7 22L10 22C10.2761 22 10.5 22.2239 10.5 22.5C10.5 22.7761 10.2761 23 10 23L7 23C6.72386 23 6.5 22.7761 6.5 22.5Z",
    fill: "#404040"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.5C13.5 10.2239 13.7239 10 14 10H18C18.2761 10 18.5 10.2239 18.5 10.5C18.5 10.7761 18.2761 11 18 11H14C13.7239 11 13.5 10.7761 13.5 10.5Z",
    fill: "#404040"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13.5C13.5 13.2239 13.7239 13 14 13H18C18.2761 13 18.5 13.2239 18.5 13.5C18.5 13.7761 18.2761 14 18 14H14C13.7239 14 13.5 13.7761 13.5 13.5Z",
    fill: "#404040"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 16.5C13.5 16.2239 13.7239 16 14 16H18C18.2761 16 18.5 16.2239 18.5 16.5C18.5 16.7761 18.2761 17 18 17H14C13.7239 17 13.5 16.7761 13.5 16.5Z",
    fill: "#404040"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 19.5C13.5 19.2239 13.7239 19 14 19H18C18.2761 19 18.5 19.2239 18.5 19.5C18.5 19.7761 18.2761 20 18 20H14C13.7239 20 13.5 19.7761 13.5 19.5Z",
    fill: "#404040"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 22.5C13.5 22.2239 13.7239 22 14 22H18C18.2761 22 18.5 22.2239 18.5 22.5C18.5 22.7761 18.2761 23 18 23H14C13.7239 23 13.5 22.7761 13.5 22.5Z",
    fill: "#404040"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9C6.5 9.55228 6.05228 10 5.5 10C4.94772 10 4.5 9.55228 4.5 9C4.5 8.44772 4.94772 8 5.5 8C6.05228 8 6.5 8.44772 6.5 9Z",
    fill: "#141515"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10C6.05228 10 6.5 9.55228 6.5 9C6.5 8.44772 6.05228 8 5.5 8C4.94772 8 4.5 8.44772 4.5 9C4.5 9.55228 4.94772 10 5.5 10Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCity);
export default __webpack_public_path__ + "static/media/smart-city.3761c419.svg";
export { ForwardRef as ReactComponent };